/** Tipos de promoções das campanhas */
export interface TipoPromocaoCampanha {
    id: number;
    nome: string;
    nomeApresentacao: string;
}

export const tipoPromocaoSemPromocao: TipoPromocaoCampanha = {
    id: 1,
    nome: 'Sem Promoção',
    nomeApresentacao: 'Sem Promoção'
};

export const tipoPromocaoCliente: TipoPromocaoCampanha = {
    id: 2,
    nome: 'Cliente',
    nomeApresentacao: 'Promoção de Clientes'
};

export const tipoPromocaoItem: TipoPromocaoCampanha = {
    id: 3,
    nome: 'Item',
    nomeApresentacao: 'Promoção de itens'
};


export const tiposPromocoes: TipoPromocaoCampanha[] = [
    tipoPromocaoSemPromocao,
    tipoPromocaoCliente,
    tipoPromocaoItem
];

/** Verifica se o tipo de promoção informado é igual a sem promoção */
export function isTipoPromocaoSemPromocao(tipoPromocao: number): boolean {
    if (!tipoPromocao) {
        return false;
    }
    return tipoPromocao === tipoPromocaoSemPromocao.id;
}

/** Verifica se o tipo de promoção informado é igual a Cliente */
export function isTipoPromocaoCliente(tipoPromocao: number): boolean {
    if (!tipoPromocao) {
        return false;
    }
    return tipoPromocao === tipoPromocaoCliente.id;
}


/** Verifica se o tipo de promoção informado é igual a Item */
export function isTipoPromocaoItem(tipoPromocao: number): boolean {
    if (!tipoPromocao) {
        return false;
    }
    return tipoPromocao === tipoPromocaoItem.id;
}
